// Logo Slider
jQuery(function () {
    jQuery('.logo-slider').slick({
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        arrows: false,
        swipe: false,
        slidesToShow: 5,
        cssEase: 'linear',
        pauseOnFocus: false,
        pauseOnHover: false,
        responsive: [
            {
        breakpoint: 512,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 370,
        settings: {
          slidesToShow: 2,
        }
      }
        ]
    });
});

// Image with accordioan FAQ
  $(function() {	
	//BEGIN
	$(".accordion__title").on("click", function(e) {
		e.preventDefault();
		var $this = $(this);
		if (!$this.hasClass("accordion-active")) {
			$(".accordion__content").slideUp(400);
			$(".accordion__title").removeClass("accordion-active");
			$('.accordion__arrow').removeClass('accordion__rotate');
		}
		$this.toggleClass("accordion-active");
		$this.next().slideToggle();
		$('.accordion__arrow',this).toggleClass('accordion__rotate');
	});	
});